export default __webpack_public_path__ + "static/fund-houses-444b11b7a70b18ccd705c9f89534a9f0.png";